import {
    ChannelInviteModal,
    CloseConversation,
    ConfirmationModal,
    EditCannedMessage,
    EndConversationAction,
    IdentityModalAction,
    ModalActionType,
    TransferConversationAction,
} from '../../actions/modal/types'
import {AnyAction} from '@reduxjs/toolkit'

export interface ModalState {
    endConversation?: EndConversationAction['payload'],
    channelInviteModal?: ChannelInviteModal['payload'],
    closeConversation?: CloseConversation['payload'],
    editCannedMessage?: EditCannedMessage['payload'],
    confirmationModal?: ConfirmationModal['payload'],
    transferConversation?: TransferConversationAction['payload']
    identityModal?: IdentityModalAction['payload']
}

// don't have any modal currently visible as default
const defaultState: ModalState = {}

const modalReducer = (state: ModalState = defaultState, action: AnyAction) : ModalState => {
    switch (action.type) {
        case ModalActionType.END_CONVERSATION: {
            const {channelId} = action.payload
            const {show} = action.meta
            if (show) {
                return {
                    ...state,
                    endConversation: {channelId},
                }
            }
            const {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                endConversation: _, ...rest
            } = state
            return rest
        }
        case ModalActionType.CHANNEL_INVITE_MODAL: {
            const {
                accessKey, noRedirectOnCancel,
            } = action.payload
            const {show} = action.meta
            if (show) {
                return {
                    ...state,
                    channelInviteModal: {
                        accessKey,
                        noRedirectOnCancel,
                    },
                }
            }
            const {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                channelInviteModal: _, ...rest
            } = state
            return rest
        }
        case ModalActionType.CLOSE_CONVERSATION: {
            const {channelId} = action.payload
            const {show} = action.meta
            if (show) {
                return {
                    ...state,
                    closeConversation: {channelId},
                }
            }
            const {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                closeConversation: _, ...rest
            } = state
            return rest
        }
        case ModalActionType.CONFIRMATION_MODAL: {
            const {
                onConfirm,
                text,
                title,
            } = action.payload
            const {show} = action.meta
            if (show) {
                return {
                    ...state,
                    confirmationModal: {
                        onConfirm,
                        text,
                        title,
                    },
                }
            }
            const {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                confirmationModal: _, ...rest
            } = state
            return rest
        }
        case ModalActionType.EDIT_CANNED_MESSAGE: {
            const {
                keyword,
                message,
                organization,
                realmId,
            } = action.payload
            const {show} = action.meta
            if (show) {
                return {
                    ...state,
                    editCannedMessage: {
                        keyword,
                        message,
                        organization,
                        realmId,
                    },
                }
            }
            const {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                editCannedMessage: _, ...rest
            } = state
            return rest
        }
        case ModalActionType.TRANSFER_CONVERSATION: {
            const {
                channelId, queueId,
            } = action.payload
            const {show} = action.meta
            if (show) {
                return {
                    ...state,
                    transferConversation: {
                        channelId,
                        queueId,
                    },
                }
            }
            const {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                transferConversation: _, ...rest
            } = state
            return rest
        }
        case ModalActionType.IDENTITY: {
            const {
                identity, identityType,
            } = action.payload
            const {show} = action.meta
            if (show) {
                return {
                    ...state,
                    identityModal: {
                        identity,
                        identityType,
                    },
                }
            }
            const {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                identityModal, ...rest
            } = state
            return rest
        }
        default:
            return {...state}
    }
}

export {
    modalReducer,
}
